import { FetchContext } from '../fetch-context';
import { AwardGroupsSummary } from '../../models';
import { responseErrorHandler } from '../response-error-handler';

export const getAwardGroupsSummaries: (
  fetchContext: FetchContext,
  programId: number,
  accessToken?: string,
) => Promise<AwardGroupsSummary[]> = (fetchContext, programId, accessToken) => fetch(`${fetchContext.baseUrl}/api/staff/programs/${programId}/award-groups-summaries`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<AwardGroupsSummary[]>(fetchContext.errorStore, response, 'get award groups summaries'));
